<template>
  <div class="info-box col-auto d-flex flex-column justify-content-center align-items-center px-4">
    <img alt="landscape" src="@/assets/sunrise.svg" class="sunrise-img" />
    <div class="my-4 text-center">
      <slot name="message"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
/**
 * This component shows an image and a message. It can be used to show some messages to user
 * slots
 * - message
 * - default: this gets rendered after image and message
 */
export default {
  name: 'InfoBox'
}
</script>

<style scoped>
.info-box {
  max-width: 480px;
}
</style>
